import Editor from "../../../components/Editor";
import InputWithVariablePicker from "../../components/InputWithVariablePicker";
import ActivitySender from "../../../activities/ActivitySender";
import { fromJS } from "immutable";
import type { RuleItemEditorBaseProps } from "../ruleItemEditorTypes";
import AddVariableIcon from "../../../icons/svg/add_variable.svg?react";

type Props = RuleItemEditorBaseProps & {
  data: any;
  editorBodyRef?: React.RefObject<{
    getModule?: (name: string) => { openMenu?: (trigger: string) => void };
  }>;
};

export default function RuleItemEditorEmail({
  ruleItem,
  updateRuleItem,
  rule,
  readonly,
  attributes,
  t,
  data,
  editorBodyRef,
}: Props) {
  const emailVariablesHint = t(
    "Email variables hint",
    "Type {{ to add variables. e.g. {{contact.email}}, {{contact.name}}, {{sale.title}}"
  );
  const senderEventData = { organizer: data.sender ?? "" };
  const handleSenderChange = (field: string, value: string) => {
    if (field === "organizer") {
      updateRuleItem({
        ...ruleItem,
        data: { ...ruleItem.data, sender: value },
      });
    }
  };

  return (
    <div className="flex flex-col gap-5 w-full max-w-2xl">
      <ActivitySender
        title={t("Sender")}
        addButtonText={t("Add Sender")}
        projectId={rule?.get?.("projectId")}
        eventData={senderEventData}
        handleChange={handleSenderChange}
      />
      <InputWithVariablePicker
        label={t("To")}
        value={data.receivers ?? ""}
        onChange={(value) =>
          updateRuleItem({
            ...ruleItem,
            data: { ...ruleItem.data, receivers: value },
          })
        }
        placeholder={t("Emails or {{contact.email}}")}
        readOnly={readonly}
        attributes={attributes}
        projectId={rule?.get?.("projectId")}
        variableFilter={(v) => v.toLowerCase().includes("email")}
        autoFormat
      />
      <InputWithVariablePicker
        label={t("Subject")}
        value={data.subject ?? ""}
        onChange={(value) =>
          updateRuleItem({
            ...ruleItem,
            data: { ...ruleItem.data, subject: value },
          })
        }
        placeholder={t("e.g. Hello {{contact.name}}")}
        readOnly={readonly}
        attributes={attributes}
      />
      <div className="flex flex-col gap-1.5">
        <div className="flex items-center justify-between gap-2">
          <label className="text-sm font-medium text-gray-700 shrink-0">{t("Body")}</label>
          {!readonly && (
            <button
              type="button"
              className="inline-flex items-center gap-1.5 text-xs font-medium text-gray-500 hover:text-gray-700 transition-colors"
              onClick={() => {
                editorBodyRef?.current?.getModule?.("mention")?.openMenu?.("{{");
              }}
            >
              <AddVariableIcon className="w-[14px] h-[14px] shrink-0" />
              <span>{t("Insert variable")}</span>
            </button>
          )}
        </div>
        <div className="rounded-lg border border-gray-200 bg-white overflow-hidden [&_.ql-container]:border-0! [&_.ql-editor]:min-h-[120px]">
          <Editor
            editorInputRef={editorBodyRef}
            showToolbar={false}
            placeholder={t("Email body placeholder", "Type your message. Use {{ to add variables")}
            minRows={4}
            members={fromJS([])}
            attributes={attributes}
            readOnly={readonly}
            editorContent={{
              htmlContent: data.body ?? "",
              contents: {},
            }}
            onChange={(content) => {
              updateRuleItem({
                ...ruleItem,
                data: { ...ruleItem.data, body: content.htmlContent },
              });
            }}
          />
        </div>
        <p className="text-xs text-gray-500">{emailVariablesHint}</p>
      </div>
    </div>
  );
}
